module.exports = __webpack_public_path__ + "static/media/2lky6BC.461b17b6.png";